import { NgModule } from '@angular/core';
import {
  MatInputModule,
  MatTabsModule,
  MatIconModule,
  MatFormFieldModule,
  MatSortModule,
  MatPaginatorModule,
  MatTableModule,
  MatButtonModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatRadioModule,
  MatAutocompleteModule,
  MatDialogModule,
  MatSelectModule,
  MatChipsModule
} from '@angular/material';

const modules = [
  MatInputModule,
  MatTabsModule,
  MatIconModule,
  MatFormFieldModule,
  MatSortModule,
  MatPaginatorModule,
  MatTableModule,
  MatButtonModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatRadioModule,
  MatAutocompleteModule,
  MatDialogModule,
  MatSelectModule,
  MatChipsModule
];

@NgModule({
  imports: [modules],
  exports: [modules],
})
export class CustomMaterialModuleModule { }
